import { Reveal, Overline } from "./Reveal";

const items = [
  {
    title: "Local & reliable",
    text: "Based in Basildon, never far away — and we turn up when we say we will.",
  },
  {
    title: "Clear communication",
    text: "Plain-English explanations and written quotes, so you always know where you stand.",
  },
  {
    title: "Professional workmanship",
    text: "Neat, safe work that meets current regulations, tested before we pack up.",
  },
  {
    title: "Easy to contact",
    text: "Call, email or send the form — you'll get a real reply, quickly.",
  },
];

const WhyUs = () => (
  <section data-testid="why-us-section" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal className="max-w-2xl mb-14 md:mb-20">
        <Overline>Why choose us</Overline>
        <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Four good reasons to call
        </h2>
      </Reveal>

      <div>
        {items.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.06}>
            <div
              data-testid={`why-us-item-${i + 1}`}
              className="grid md:grid-cols-12 gap-4 md:gap-8 items-baseline border-t border-slate-200 last:border-b py-9 md:py-12"
            >
              <span className="md:col-span-3 font-heading text-6xl md:text-7xl font-bold leading-none text-slate-200">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="md:col-span-4 text-xl md:text-2xl font-bold text-slate-900">
                {item.title}
              </h3>
              <p className="md:col-span-5 text-base leading-relaxed text-slate-600">
                {item.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
